import { MessageHandlerBase } from "./MessageHandlerBase";
const NavigationRestrictedAppEvent = "ConsumerCenterNavigationRestricted";
export default class DeepLinkRespHandler extends MessageHandlerBase {
    handle(message) {
        if (message.userData && message.userData.link) {
            this.apiUtils.minimizeInMobileView();
            window.location.href = message.userData.link;
        }
        else if (message.userData && message.userData.restrictedMsg) {
            this.sendAppEvent(message, NavigationRestrictedAppEvent);
        }
    }
    createApiParams(message) {
        var _a, _b;
        const apiParams = super.createApiParams(message);
        apiParams.RestrictionMessage = (_a = message.userData) === null || _a === void 0 ? void 0 : _a.restrictedMsg;
        apiParams.RestrictionPhoneNumber = (_b = message.userData) === null || _b === void 0 ? void 0 : _b.phoneNumber;
        delete apiParams.UserObj;
        return apiParams;
    }
}
